function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "6",
  height: "10",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("g", {
  id: "Nearest-flight",
  transform: "translate(-1169 -569)"
}, /*#__PURE__*/React.createElement("g", {
  id: "desktop",
  transform: "translate(216 532)"
}, /*#__PURE__*/React.createElement("g", {
  id: "link-Atoms-/-Buttons-/-Text-/-Secondary-/-Circle-Right",
  transform: "translate(883 30)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-Common-/-16-/-ChevronRight",
  transform: "translate(63 2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 9.664l2.793 2.793a1 1 0 001.414-1.414l-3.5-3.5a1 1 0 00-1.414 0l-3.5 3.5a1 1 0 001.414 1.414L10 9.664z",
  id: "ChevronRight",
  transform: "rotate(90 10 10)"
}))))))));